import { ApplyEvent } from '@zr/utilities/api/createResponse';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

/**
 * This component depends on Google Tag Manager (GTM) being loaded
 * and a window.dataLayer array being present. Events can be registered
 * by pushing to the dataLayer array.
 */
export function handleJobApplyEvent(response: ApplyEvent): void {
  const { dataLayer } = window;

  if (!response.already_applied && dataLayer) {
    dataLayer.push({
      event: 'job_apply',
      response: {
        response_id: response.response_id,
        transaction_id: response.transaction_id,
        source: response.new_response_source,
      },
      job: {
        job_id: response.new_response_quiz_id,
        lvk: response.new_response_lvk,
      },
      contact: {
        contact_id: response.new_response_contact_id,
        first_apply: response.first_apply,
        first_apply_source: response.first_apply_source,
        is_responder: response.is_responder,
        is_mau: response.is_mau,
        last_mau: response.last_mau,
        prior_mau: response.prior_mau,
      },
    });
  }
}
